module.exports = __webpack_public_path__ + "img/get.e329f7f8.jpg";